<div class="content-wrapper-inner relative">
    <app-disabled-section-widget [service]="'motc'" (changeState)="testingDisabled = !$event.service"></app-disabled-section-widget>
    <div *ngIf="testingDisabled === false">
        <div class="create-test-section border">
            <app-mo-form (onAfterSave)="afterSave($event)" [pauseUpdate]="pauseUpdateForm"></app-mo-form>
        </div>
        <app-mo-search-form (onSubmit)="onSubmitFilter($event)"></app-mo-search-form>
        <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
            <app-mo-results-table (onRepeat)="onRepeat($event)"></app-mo-results-table>
        </div>
    </div>
</div>
